/**
 * RESPONSIBILITY: draw a band that is one YouTube video.
 *
 * The player the sermons use: YouTube's own still first, the video in place on a click. A
 * link that is not a video falls through to opening in a new tab.
 */
import { VideoPlayer } from '../VideoPlayer';
import { YoutubeThumb } from '../YoutubeThumb';
import { BandFrame } from './BandFrame';
import type { BandDef, BandProps } from './kind';

function Draw({ b, tinted }: BandProps) {
  return (
    <BandFrame tinted={tinted} heading={b.heading}>
      <div className="ministry-video">
        <VideoPlayer
          url={b.videoHref}
          title={b.heading || b.videoHref || ''}
          picture={<YoutubeThumb url={b.videoHref} alt={b.heading ?? ''} className="video-pic" />}
        />
      </div>
    </BandFrame>
  );
}

export const video: BandDef = { has: (b) => !!b.videoHref, Draw };
